import {useFocusEffect, useNavigation} from '@react-navigation/core';
import React from 'react';

import {ModalWrapper} from 'components/ModalWrapper';
import ConnectedLinkAffiliateAccount from 'containers/LinkAffiliateAccount';
import {usePageViewEvent} from 'hooks/usePageViewEvent';
import {Routes} from 'models/Navigation';

const LinkAccountScreen: React.FunctionComponent = () => {
  const navigation = useNavigation();

  const {trackPageViewEvent} = usePageViewEvent();

  useFocusEffect(trackPageViewEvent);

  return (
    <ModalWrapper onClosePress={() => navigation.navigate(Routes.Main.Home)}>
      <ConnectedLinkAffiliateAccount />
    </ModalWrapper>
  );
};

export default LinkAccountScreen;
